import { connect } from 'react-redux';

import {
  loadDataSink,
  fetchResourceMetricsAggregate,
  fetchResourceMetricsPerDay,
} from '../../../actions';

import { getMetricsForSink } from '../../../reducers/selectors';
import { CONNECTION_CATEGORY_DATA_MAP } from '../../../constants/connectionCategories';
import DataSinkOverviewTab from './DataSinkOverviewTab';
import has from 'lodash/has';
import { getConnectionOrVendorType } from '../../../lib/ResourceUtils';
import { isReadOnly } from '../../../lib/ACLUtils';

const mapStateToProps = (state, ownProps) => {
  const { data } = ownProps;
  const {
    request,
    entities: { credentials, dataMaps, dataSets, vendors },
    paging: { metaInfoById, sinkConfigById, llmConfigById },
  } = state;

  let connectionOrVendorType = getConnectionOrVendorType(data, vendors, 'sink_type', 'vendor_id');

  const connectionCategory =
    metaInfoById && has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType].connectionCategory
      : null;

  const isDataMap = connectionCategory && connectionCategory === CONNECTION_CATEGORY_DATA_MAP;
  const dataMap =
    isDataMap && has(data, 'data_map_id') && has(dataMaps, data.data_map_id)
      ? dataMaps[data.data_map_id]
      : null;

  const isWritingDataset = has(data, 'data_set_id') && data.data_set_id ? true : false;

  const writingDataSet =
    isWritingDataset && has(dataSets, data.data_set_id) ? dataSets[data.data_set_id] : null;

  const resourceTypeFields = (() => {
    if (data.node_type === 'llm_processor') {
      return llmConfigById && has(llmConfigById, connectionOrVendorType)
        ? llmConfigById[connectionOrVendorType]
        : [];
    }
    return sinkConfigById && has(sinkConfigById, connectionOrVendorType)
      ? sinkConfigById[connectionOrVendorType]
      : [];
  })();
  const readOnly = isReadOnly(data);
  return {
    connectionCategory,
    isDataMap,
    dataMap,
    resourceTypeFields,
    credentials: data ? credentials[data.data_credentials] : null,
    dataMaps: dataMaps,
    metrics: getMetricsForSink(state, ownProps),
    isWritingDataset,
    writingDataSet,
    isLoading: {
      aggMetrics: request.GET_RESOURCE_METRICS_AGGREGATE_REQUEST || false,
      dayMetrics: request.GET_RESOURCE_METRICS_BY_DAYS_REQUEST || false,
    },
    readOnly,
  };
};
export default connect(mapStateToProps, {
  loadDataSink,
  fetchResourceMetricsPerDay,
  fetchResourceMetricsAggregate,
})(DataSinkOverviewTab);
